export enum RequestVersionChangeTracking {
	Available = "AVAILABLE",
	Unavailable = "UNAVAILABLE",
}
